import React from 'react';

import { replaceSymbols } from '@utils/Util';

const CollectionInfo = ({ collectionName, season, collectionId }) => {
	return (
		<div className="style-single mb-2">
			<div className="label-box">
				<ul>
					<li className="regular-12 weight-500 gray_dark_02 mb-1">
						<span className="name">Collection</span>
						<span>:</span>
						<span
							className="gray_dark_01 border-btm cursor-pointer ml-1"
							onClick={() => window.open(`/collections/view/${collectionId}`, '_blank')}
						>
							{collectionName}
						</span>
					</li>
					<li className="regular-12 weight-500 gray_dark_02">
						<span className="name">Season</span>
						<span>:</span>
						<span className="gray_dark_01"> {replaceSymbols(season, '_')}</span>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default CollectionInfo;
